import React, {
    useContext,
    useEffect,
    useRef,
    useState
} from 'react';
import {
    Link,
    useLocation
} from 'react-router-dom';
import { SideNavContext } from '../../contexts';
import './drawer.css';

const Drawer = () => {
    const {
        isSideNavOpen,
        toggleSideNav
    } = useContext(SideNavContext);

    const [isProductOpen, setIsProductOpen] =
        useState(false);

    const sideNavRef =
        useRef(null);

    const location =
        useLocation();

    useEffect(() => {
        const handleKeyUp = (event) => {
            if (
                event.key === 'Escape' &&
                isSideNavOpen
            ) {
                toggleSideNav.close();
            }
        };

        const handleClickOutside = (event) => {
            if (
                sideNavRef.current &&
                !sideNavRef.current.contains(
                    event.target
                )
            ) {
                toggleSideNav.close();
            }
        };

        if (isSideNavOpen) {
            document.addEventListener(
                'keyup',
                handleKeyUp
            );

            document.addEventListener(
                'mousedown',
                handleClickOutside
            );

            document.body.style.overflow =
                'hidden';
        }

        return () => {
            document.removeEventListener(
                'keyup',
                handleKeyUp
            );

            document.removeEventListener(
                'mousedown',
                handleClickOutside
            );

            document.body.style.overflow =
                '';
        };
    }, [
        isSideNavOpen,
        toggleSideNav
    ]);

    useEffect(() => {
        if (
            location.pathname.startsWith(
                '/products/'
            )
        ) {
            setIsProductOpen(true);
        }
    }, [location.pathname]);

    const closeDrawer = () => {
        toggleSideNav.close();
    };

    const toggleProduct = () => {
        setIsProductOpen(
            (prev) => !prev
        );
    };

    const isActive = (path) => {
        return (
            location.pathname === path ||
            location.pathname.startsWith(
                `${path}/`
            )
        );
    };

    return (
        <>
            <div
                className={
                    isSideNavOpen
                        ? 'layout-dim active'
                        : 'layout-dim'
                }
            >
            </div>

            <aside
                ref={sideNavRef}
                className={
                    isSideNavOpen
                        ? 'layout-drawer is-open'
                        : 'layout-drawer'
                }
            >

                {/* HEADER */}
                <div className="drawer-header">

                    <div className="drawer-header-top">

                        <Link
                            to="/"
                            className="drawer-logo"
                            onClick={closeDrawer}
                        >
                            <img
                                src="/images/logo5.png"
                                alt="MTMEDIA"
                            />
                        </Link>

                        <button
                            type="button"
                            className="drawer-close"
                            onClick={closeDrawer}
                            aria-label="메뉴 닫기"
                        >
                            <i className="mdi mdi-close"></i>
                        </button>

                    </div>

                    <div className="drawer-company">
                        <p>
                            LED DISPLAY · PROJECTOR
                        </p>
                        <span>
                            LED 전광판 · 빔프로젝터 전문 기업
                        </span>

                    </div>

                </div>

                {/* MAIN MENU */}
                <nav className="drawer-navigation">

                    <Link
                        to="/business"
                        className={
                            isActive('/business')
                                ? 'drawer-menu active'
                                : 'drawer-menu'
                        }
                        onClick={closeDrawer}
                    >
                        <div className="drawer-menu-icon">
                            <i className="mdi mdi-briefcase-outline"></i>
                        </div>

                        <span>
                            사업분야
                        </span>

                        <i className="mdi mdi-chevron-right drawer-menu-arrow"></i>
                    </Link>

                    <Link
                        to="/rentalService"
                        className={
                            isActive('/rentalService')
                                ? 'drawer-menu active'
                                : 'drawer-menu'
                        }
                        onClick={closeDrawer}
                    >
                        <div className="drawer-menu-icon">
                            <i className="mdi mdi-book-open-page-variant-outline"></i>
                        </div>

                        <span>
                            서비스 가이드
                        </span>

                        <i className="mdi mdi-chevron-right drawer-menu-arrow"></i>
                    </Link>

                    {/* PRODUCT */}
                    <div
                        className={
                            isProductOpen
                                ? 'drawer-product active'
                                : 'drawer-product'
                        }
                    >

                        <button
                            type="button"
                            className={
                                location.pathname.startsWith(
                                    '/products/'
                                )
                                    ? 'drawer-menu active'
                                    : 'drawer-menu'
                            }
                            onClick={toggleProduct}
                            aria-expanded={isProductOpen}
                        >
                            <div className="drawer-menu-icon">
                                <i className="mdi mdi-monitor-multiple"></i>
                            </div>

                            <span>
                                제품소개
                            </span>

                            <i
                                className={
                                    isProductOpen
                                        ? 'mdi mdi-chevron-up drawer-menu-arrow'
                                        : 'mdi mdi-chevron-down drawer-menu-arrow'
                                }
                            ></i>
                        </button>

                        <div className="drawer-product-sub">

                            <Link
                                to="/products/led"
                                className={
                                    location.pathname ===
                                    '/products/led'
                                        ? 'active'
                                        : ''
                                }
                                onClick={closeDrawer}
                            >
                                <span>
                                    LED
                                </span>

                                <div>
                                    <strong>
                                        LED 전광판
                                    </strong>

                                    <small>
                                        LED DISPLAY
                                    </small>
                                </div>

                                <i className="mdi mdi-chevron-right"></i>
                            </Link>

                            <Link
                                to="/products/projector"
                                className={
                                    location.pathname ===
                                    '/products/projector'
                                        ? 'active'
                                        : ''
                                }
                                onClick={closeDrawer}
                            >
                                <span>
                                    PJ
                                </span>

                                <div>
                                    <strong>
                                        빔프로젝터
                                    </strong>

                                    <small>
                                        PROJECTOR
                                    </small>
                                </div>

                                <i className="mdi mdi-chevron-right"></i>
                            </Link>

                        </div>

                    </div>

                    <Link
                        to="/portfolio"
                        className={
                            isActive('/portfolio')
                                ? 'drawer-menu active'
                                : 'drawer-menu'
                        }
                        onClick={closeDrawer}
                    >
                        <div className="drawer-menu-icon">
                            <i className="mdi mdi-image-multiple-outline"></i>
                        </div>

                        <span>
                            시공사례
                        </span>

                        <i className="mdi mdi-chevron-right drawer-menu-arrow"></i>
                    </Link>

                    <Link
                        to="/support"
                        className={
                            isActive('/support')
                                ? 'drawer-menu active'
                                : 'drawer-menu'
                        }
                        onClick={closeDrawer}
                    >
                        <div className="drawer-menu-icon">
                            <i className="mdi mdi-headset"></i>
                        </div>

                        <span>
                            고객지원
                        </span>

                        <i className="mdi mdi-chevron-right drawer-menu-arrow"></i>
                    </Link>

                </nav>

                {/* INQUIRY */}
                <div className="drawer-inquiry">

                    <Link
                        to="/inquiry"
                        onClick={closeDrawer}
                    >
                        <div>
                            <span>
                                QUICK INQUIRY
                            </span>

                            <strong>
                                견적문의
                            </strong>
                        </div>

                        <i className="mdi mdi-arrow-right"></i>
                    </Link>

                </div>

                {/* CONTACT */}
                <div className="drawer-contact">

                    <p>
                        CUSTOMER CENTER
                    </p>

                    <a
                        href="tel:01090453707"
                        className="drawer-contact-phone"
                    >
                        <i className="mdi mdi-phone-outline"></i>

                        <div>
                            <span>
                                전화 상담
                            </span>

                            <strong>
                                010-9045-3707
                            </strong>
                        </div>
                    </a>

                    <a
                        href="mailto:mtmedia91@gmail.com"
                        className="drawer-contact-email"
                    >
                        <i className="mdi mdi-email-outline"></i>

                        mtmedia91@gmail.com
                    </a>

                </div>

                {/* FOOTER */}
                <div className="drawer-footer">

                    <span>
                        MTMEDIA
                    </span>

                    <p>
                        LED DISPLAY · PROJECTOR RENTAL
                    </p>

                </div>

            </aside>
        </>
    );
};

export default Drawer;